import { useEffect, useState } from 'react'
import AppBar from '@mui/material/AppBar'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import IconButton from '@mui/material/IconButton'
import Toolbar from '@mui/material/Toolbar'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useAtomValue } from 'jotai'
import { useLocation, useNavigate } from 'react-router'
import { authenticationState, customerState } from '@repo/unicity'
import { countryState, feelgreatCountryAtom } from '@/core/store/country.store'
import { SelectCountryModal } from '@/core/components/select-country'
import LogoIcon from './assets/logo-wo-tm.svg?react'
import ProfileIcon from './assets/profile.svg?react'

const SHADOW_PAGES = ['/products', '/checkout']

export const HeaderLayout = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const country = useAtomValue(countryState)
    const fgCountry = useAtomValue(feelgreatCountryAtom)
    const authentication = useAtomValue(authenticationState)
    const customer = useAtomValue(customerState)

    const isLoggedIn = Boolean(authentication.token && authentication.baId)
    const profilePicUrl = customer.profilePicture?.sizes?.[0]?.media || customer.profilePicture?.href || ''
    const customerName = customer.humanName?.fullName || customer.humanName?.firstName || ''

    const isSmall = useMediaQuery('(max-width:899px)')
    const isLarge = useMediaQuery('(min-width:1920px)')

    const [showShadow, setShowShadow] = useState(false)
    const [countryModalOpen, setCountryModalOpen] = useState(false)

    useEffect(() => {
        setShowShadow(SHADOW_PAGES.some(p => location.pathname.startsWith(p)))
    }, [location.pathname])

    const padding = isSmall ? '20px' : isLarge ? '0px' : '30px'

    return (
        <AppBar
            position="relative"
            elevation={0}
            sx={{
                backgroundColor: '#fff',
                boxShadow: showShadow ? '0px 2px 4px rgba(0, 0, 0, 0.08)' : 'none'
            }}
            data-testid="header-app-bar">
            <Container
                maxWidth="xl"
                sx={{
                    px: `${padding} !important`,
                    height: '75px',
                    alignItems: 'center',
                    display: 'flex'
                }}
                data-testid="header-container-icon-button">
                <Toolbar
                    disableGutters
                    sx={{
                        height: '75px',
                        py: 0,
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%'
                    }}
                    data-testid="header-toolbar-logo-icon">
                    <Box sx={{ flexGrow: 1, height: '100%', display: 'flex', alignItems: 'center' }} data-testid="header-box-logo-icon-1">
                        <Box
                            sx={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}
                            onClick={() => navigate('/')}
                            data-testid="header-box-logo-icon-2">
                            <LogoIcon data-testid="header-logo-icon" />
                        </Box>
                    </Box>

                    <Box sx={{ flexGrow: 0, display: 'flex', alignItems: 'center' }} data-testid="header-box-icon-button">
                        {fgCountry?.flagUrl && (
                            <img
                                src={fgCountry.flagUrl}
                                alt={country.roman_name}
                                onClick={() => setCountryModalOpen(true)}
                                style={{
                                    marginRight: '15px',
                                    cursor: 'pointer',
                                    borderRadius: '3px',
                                    height: '20px'
                                }}
                                data-testid="header-img"
                            />
                        )}

                        <IconButton onClick={() => navigate('/login')} sx={{ p: 0 }} data-testid="header-icon-button">
                            {isLoggedIn && profilePicUrl ? (
                                <Avatar src={profilePicUrl} alt={customerName} sx={{ width: 24, height: 24 }} data-testid="header-avatar" />
                            ) : (
                                <ProfileIcon data-testid="header-profile-icon" />
                            )}
                        </IconButton>
                    </Box>
                </Toolbar>
            </Container>
            <SelectCountryModal open={countryModalOpen} onClose={() => setCountryModalOpen(false)} data-testid="header-select-country-modal" />
        </AppBar>
    )
}
